var map = {
	"./agri-assist.png": "b997",
	"./commercial-assist.png": "60eb",
	"./crime-victim-assist.png": "50ff",
	"./disability-assist.png": "ad56",
	"./emergency-medical.png": "e799",
	"./hiv-assist.png": "a669",
	"./home-assist.png": "4a39",
	"./home-safe-chauffeur.png": "52c7",
	"./intelligent-panic.png": "decc",
	"./legal-assist.png": "110f",
	"./old/agri-assist.png": "a7df",
	"./old/commercial-assist.png": "7f80",
	"./old/crime-victim-assist.png": "c1ab",
	"./old/disability-assist.png": "4f4e",
	"./old/emergency-medical.png": "cf64",
	"./old/hiv-assist.png": "f5bc",
	"./old/home-assist.png": "34cc",
	"./old/home-safe-chauffeur.png": "93ca",
	"./old/intelligent-panic.png": "35b7",
	"./old/legal-assist.png": "1349",
	"./old/roadside-assist.png": "4675",
	"./old/trauma-and-assault.png": "b37c",
	"./roadside-assist.png": "e2d7",
	"./trauma-and-assault.png": "4c6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52ff";